// @flow

import { useFormContext } from 'react-hook-form';
import type { SelectProps } from 'reshaped';

import type { FieldProps } from 'src/Reshaped/Form/types';

import { useRequiredRule } from '../../../ContactForm/hooks/useRequiredRule';

import type { FieldSchema } from './DomainContactForm';

export function SelectField({
  field: { help, label, name, required, placeholder, ...extra },
  children,
}: {
  field: FieldSchema,
  children: (props: {
    ...FieldProps<SelectProps>,
    ...FieldSchema,
  }) => React.Node,
}): React.Node {
  const { control } = useFormContext();
  const requiredRule = useRequiredRule(!!required);
  const fieldProps = {
    control,
    name,
    label,
    placeholder,
    required,
    help,
    rules: { ...requiredRule },
    ...extra,
  };
  return children(fieldProps);
}
